(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactHistoryTableController', [
            'MW.Framework.InfluencerContactService',
            'MW.Framework.CoreGridDefinition',
            'MW.Framework.CoreGridSelectableService',
            'MW.ContactManager.ContactManagerFlashService',
            'MW.Influencers.IcmDialogService',
            'MW.ContactManager.OutreachListFactory',
            'MW.Framework.MomentService',
            'MW.Framework.ICMEmailService',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Influencers.ActivityService'
        ])
        .controller('ContactHistoryTableController', [
            'breadcrumbs',
            'InfluencerContactService',
            'CoreGridDefinition',
            '$routeParams',
            'CoreGridSelectableService',
            'DialogService',
            '$translate',
            'ContactManagerFlashService',
            'ICMEmailService',
            'OutreachListFactory',
            '$location',
            '$filter',
            'moment',
            'ContactManagerNavigationService',
            'ActivityService',
            ContactHistoryTableController
        ]);

    function ContactHistoryTableController(breadcrumbs,
                                           InfluencerContactService,
                                           CoreGridDefinition,
                                           $routeParams,
                                           CoreGridSelectableService,
                                           DialogService,
                                           $translate,
                                           ContactManagerFlashService,
                                           ICMEmailService,
                                           OutreachListFactory,
                                           $location,
                                           $filter,
                                           moment,
                                           ContactManagerNavigationService,
                                           ActivityService
    ) {
        this.ActivityService = ActivityService;

        this.$filter = $filter;
        this.moment = moment;
        this.$translate = $translate;
        this.breadcrumbs = breadcrumbs;
        this.$routeParams = $routeParams;
        this.CoreGridDefinition = CoreGridDefinition;
        this.InfluencerContactService = InfluencerContactService;
        this.CoreGridSelectableService = CoreGridSelectableService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.ICMEmailService = ICMEmailService;
        this.OutreachListFactory = new OutreachListFactory();
        this.DialogService = DialogService;
        this.$location = $location;
        this.emailEmptyStateVisible = false;
        this.defaultErrorMessage = this.$translate.instant('Something has gone wrong behind the scenes. Please try again later.');
        this.ContactManagerNavigationService = ContactManagerNavigationService;

        this.coreGridNotesConfig = {}; // Notes grid definition
        this.contactEmailCollection = []; // Email collection
        this.coreGridEmailConfig = {}; // Email grid definition

        if($routeParams.typeVal && $routeParams.typeVal.toLowerCase() === 'notes') {
            this.isNotesView = true;
            this.isEmailView = false;
        } else if ($routeParams.typeVal && $routeParams.typeVal.toLowerCase() === 'email') {
            this.isNotesView = false;
            this.isEmailView = true;
        }

        InfluencerContactService.getContactById($routeParams.contactId).then(function(response) {
            var contactName;
            this.contactNotesCollection = [];
            this.contact = response;
            this.getNotes(this.contact.id);
            if(this.contact.name && this.contact.name.middleName && this.contact.name.middleName !== 'undefined') {
                contactName = this.contact.name.firstName + ' ' + this.contact.name.middleName + ' ' + this.contact.name.lastName;
            } else {
                contactName = this.contact.name.firstName + ' ' + this.contact.name.lastName;
            }
            this.tableTitle = this.$translate.instant('Contact History with') + ' ' + contactName;
            // Loading outreach emails for current contact
            this.contactEmailAddress = this.contact.contactInfo.email[0].address; // This is required to fetch outreach emails only for this contact
            this.getAllEmails();
        }.bind(this)).catch(function() {
            this.DialogService.flashError(this.defaultErrorMessage);
        }.bind(this));

        this.isButtonDisabled = function isButtonDisabled() {
            var isDisabled = true;
            if (this.contact !== undefined && this.contact.notes !== undefined) {
                isDisabled = ((this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes))).length > 0 && this.isNotesView) ? false : true;
            }
            return isDisabled;
        }.bind(this);

        // Define the core grid configuration for the ICM Notes list.
        var historyTableCoreGridConfig = {
            dataItemIdProperty: 'notesId',
            headerTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'created',
                descending: true,
                conditionalSort: function(sortField) {
                    if(sortField === 'created') {
                        return 'modifiedTimeStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [
                {
                    name: 'Delete',
                    isDisabled : this.isButtonDisabled,
                    callback: function() {
                        this.deleteNotesHandler();
                    }.bind(this)
                }
            ],
            columnDefinitions: [
                {
                    name: 'Type',
                    dataKey: 'typeDisplay',
                    options: {
                        defaultValue: 'note',
                        class: 'collectionType',
                        sortable: true,
                        searchable: true
                    }
                },
                {
                    name: 'SUBJECT',
                    dataKey: 'subjectBackup',
                    options: {
                        class: 'collectionSubject',
                        columnDataTemplateUrl: 'icm-web/views/partials/notes_subject_column',
                        clickable: true,
                        onClick: function(dataItem) {
                            this.editActivity(dataItem);
                        }.bind(this)
                    }
                },
                {
                    name: 'DATE',
                    dataKey: 'created',
                    options: {
                        class: 'collectionDate',
                        sortable: true
                    }
                 }
            ],
            selectable: {
                singleSelect: false,
                enabled: true,
                selected: []
            },
            searchable: {
                enabled: false
            }
        };

        // change the class to change the width of the column
        historyTableCoreGridConfig.columnDefinitions[1].options.class = 'activityCollectionSubject';
        historyTableCoreGridConfig.columnDefinitions.push({
            name: 'icm-web__contact-profile--activity-table-column-author',
            dataKey: 'authorName',
            options: {
                defaultValue: '',
                class: 'activityAuthor',
                sortable: true,
                searchable: true
            }
        });
        // this injects the author into the 3rd position of the array (before date)
        historyTableCoreGridConfig.columnDefinitions.splice(2, 0, historyTableCoreGridConfig.columnDefinitions.splice(3, 1)[0]);

        // Load the core grid configuration for notes on Contact History page
        this.coreGridNotesConfig = this.CoreGridDefinition.build(historyTableCoreGridConfig);

        // Define the core grid configuration for the outreach list.
        var historyTableEmailCoreGridConfig = {
            dataItemIdProperty: '_id',
            headerTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'name',
                descending: false,
                backendSorting: false,
                conditionalSort: function(sortField) {
                    if(sortField === 'scheduledDate') {
                        return 'scheduledDateStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [],
            columnDefinitions: [
                {
                    name: 'TYPE',
                    dataKey: 'type',
                    options: {
                        defaultValue: 'email',
                        class: 'collectionType',
                        sortable: false
                    }
                },
                {
                    name: 'SUBJECT',
                    dataKey: 'subject',
                    options: {
                        class: 'collectionSubject',
                        clickable: false,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_subject_column',
                        defaultValue: this.$translate.instant('No Recipients'),
                        clickCallback: function clickCallback(route) {
                            this.ICMEmailService.getIcmApprovedSenders()
                                .then(function() {
                                    this.$location.url(route);
                                }.bind(this))
                                .catch(function(error) {
                                    if(error) {
                                        this.showUnapprovedDialog();
                                    } else {
                                        this.DialogService.flashError(this.defaultErrorMessage);
                                    }
                                }.bind(this));
                        }.bind(this)
                    }
                },
                {
                    name: 'From',
                    dataKey: 'approvedSender.name',
                    options: {
                        class: 'collectionFrom',
                        sortable: true,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_from_column'
                    }
                },
                {
                    name: 'STATUS',
                    dataKey: 'status',
                    options: {
                        class: 'collectionStatus',
                        sortable: true,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_status_column'
                    }
                },
                {
                    name: 'Date', //This is lower case to match en.json
                    dataKey: 'scheduledDate',
                    options: {
                        class: 'collectionDate',
                        sortable: true,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_date_column',
                        defaultValue: this.$translate.instant('N/A')
                    }
                }
            ],
            selectable: {
                enabled: false,
                selected: [],
                singleSelect: false
            },
            searchable: {
                enabled: false,
                predictionFields: [],
                searchTerms: []
            }
        };
        // Load the core grid configuration for emails on Contact History page to use
        this.coreGridEmailConfig = this.CoreGridDefinition.build(historyTableEmailCoreGridConfig);
    }

    ContactHistoryTableController.prototype.toggleNotesEmailView = function toggleNotesEmailView() {
        this.isNotesView = !this.isNotesView;
        this.isEmailView = !this.isEmailView;
    };

    ContactHistoryTableController.prototype.getAllEmails = function getAllEmails(sortField, sortOrder) {
        var contactId = (this.contact && this.contact.id) ? this.contact.id : null,
            emailAddressArray = [];

        if(this.contact && this.contact.contactInfo && Array.isArray(this.contact.contactInfo.email) && this.contact.contactInfo.email.length) {
            this.contact.contactInfo.email.forEach(function(emailAddressObject) {
                if(emailAddressObject.address && typeof(emailAddressObject.address) ==='string' && emailAddressObject.address.length) {
                    emailAddressArray.push(emailAddressObject.address);
                }
            });
        }

        // Get all outreach emails list
        if(contactId || emailAddressArray.length) {
            this.OutreachListFactory.getAllEmails(contactId, emailAddressArray, sortField, sortOrder).then(function getAllEmailsSuccess(response) {
                if(response) {
                    this.contactEmailCollection = response.hits;
                    this.emailEmptyStateVisible = (this.contactEmailCollection.length > 0) ? false : true;
                }
            }.bind(this));
        } else {
            this.emailEmptyStateVisible = true;
        }
    };

    ContactHistoryTableController.prototype.formatNotes = function formatNotes(notes) {
        var newNotesArray = [],
            sortedNotes;

        if (Array.isArray(notes) && notes.length) {
            sortedNotes = this.$filter('orderBy')(notes, 'modifiedAt', 'desc');
            sortedNotes.forEach(function(note) {
                if(typeof note.note === 'string' && note.note.length) {
                    if (typeof note.subject !== 'string') {
                        note.subject = '';
                    }

                    newNotesArray.push({
                        notesId: note.id,
                        typeDisplay: note.type ? this.ActivityService.translateActivityType(note.type) : this.ActivityService.translateActivityType('note'),
                        type: note.type || 'note',
                        subject: note.subject,
                        subjectBackup: note.subject || note.note.substring(0, 240),
                        note: note.note,
                        date: note.date,
                        authorName: note.createdBy && note.createdBy.firstName && note.createdBy.lastName ? note.createdBy.firstName + ' ' + note.createdBy.lastName : '',
                        createdBy: note.createdBy,
                        updatedBy: note.updatedBy,
                        created: this.$filter('mwConvertDateToUserTimezone')(note.modifiedAt, 'mediumDate'),
                        createdAt: note.createdAt,
                        modifiedAt: note.modifiedAt,
                        modifiedTimeStamp: this.moment.utc(note.modifiedAt).format('X')
                    });
                }
            }.bind(this));
        }

        return newNotesArray;
    };

    ContactHistoryTableController.prototype.onNotesUpdated = function onNotesUpdated(notePromise) {
        notePromise
            .then(function () {
                this.InfluencerContactService.getContactById(this.contact.id).then(function(response) {
                    this.contact = response;
                    this.getNotes(this.contact.id);
                    this.ContactManagerFlashService.flashSuccess('Success. Your contact has been updated.');
                }.bind(this));
            }.bind(this))
            .catch(function (error) {
                if (error.message === 'Add failed') {
                    this.contactNotesCollection.shift();
                }
                this.ContactManagerFlashService.flashError(error);
            }.bind(this));
    };

    ContactHistoryTableController.prototype.getNotes = function getNotes(contactId) {
        // retrieve notes for the contact. since we dont return them for list views they dont get cached in the InfluencerContactService
        this.InfluencerContactService.getNotes(contactId)
            .then(function(notes) {
                this.contact.notes = notes;
                this.contactNotesCollection = this.formatNotes(notes);
            }.bind(this))
            .catch(function() {
                this.DialogService.flashError('Failed retrieving notes');
            }.bind(this));
    };

    ContactHistoryTableController.prototype.addActivity = function addActivity() {
        var createActivityPromise = this.ActivityService.createActivity(this.contact.id);
        this.onNotesUpdated(createActivityPromise);       
    };

    ContactHistoryTableController.prototype.editActivity = function editActivity(oldNote) {
        var updateActivityPromise = this.ActivityService.updateActivity(this.contact.id, oldNote);
        this.onNotesUpdated(updateActivityPromise);
    };

    ContactHistoryTableController.prototype.deleteNotesHandler = function deleteNotesHandler() {
        var confirmMessageText = this.$translate.instant('Are you sure you want to delete the selected note(s)?'),
            confirmMessageTitle = this.$translate.instant('Delete note(s)?');

        this.DialogService.confirm(confirmMessageText, confirmMessageTitle, function(payload) {
            if(payload.success) {
                var selectedNotes = this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes)),
                    notesToDelete = [];

                if(selectedNotes.length > 0) {
                    this.CoreGridSelectableService.deleteAllInSelected(this.coreGridNotesConfig);

                    notesToDelete = selectedNotes.map(function(selectedNote) {
                        return selectedNote.notesId;
                    });

                    this.onNotesUpdated(this.InfluencerContactService.deleteNotes(this.contact.id, notesToDelete));
                }
            }
        }.bind(this));
    };

    ContactHistoryTableController.prototype.showUnapprovedDialog = function() {
        var dialogTitle = this.$translate.instant('Compose Email'),
            callback = function callback() {
                this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
            }.bind(this);
        this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, callback);
    };
}());